module.exports = __webpack_public_path__ + "img/DisabledFeedbackOkay.3da01220.png";